import type { RouteRecordRaw } from 'vue-router'
import { PERMISSIONS } from '@/core/permissions/constants'

export const ticketRoutes: RouteRecordRaw[] = [
  {
    path: '/tickets',
    name: 'tickets',
    component: () => import('@/modules/tickets/views/TicketsListView.vue'),
    meta: {
      permission: PERMISSIONS.TICKETS.LIST,
      projectScoped: true,
    },
  },
  {
    path: '/tickets/:id',
    name: 'ticket-show',
    redirect: (to) => ({
      path: '/tickets',
      query: { detail: to.params.id as string },
    }),
  },
]
